import { Currency } from "../../utils/Currency";
import { DateUtil } from "../../utils/DateUtil";
export class BillPaymentDetail {
    depositId;
    allocatedPrincipal;
    allocatedInterest;
    allocatedFees;
    allocatedTotal;
    date;
    constructor(params) {
        this.depositId = params.depositId;
        this.allocatedPrincipal = Currency.of(params.allocatedPrincipal);
        this.allocatedInterest = Currency.of(params.allocatedInterest);
        this.allocatedFees = Currency.of(params.allocatedFees);
        this.allocatedTotal = this.allocatedPrincipal.add(this.allocatedInterest).add(this.allocatedFees);
        this.date = DateUtil.normalizeDate(params.date);
    }
    get jsAllocatedPrincipal() {
        return this.allocatedPrincipal.toNumber();
    }
    get jsAllocatedInterest() {
        return this.allocatedInterest.toNumber();
    }
    get jsAllocatedFees() {
        return this.allocatedFees.toNumber();
    }
    get jsAllocatedTotal() {
        return this.allocatedTotal.toNumber();
    }
    get jsDate() {
        return DateUtil.normalizeDateToJsDate(this.date);
    }
    get json() {
        return {
            depositId: this.depositId,
            allocatedPrincipal: this.jsAllocatedPrincipal,
            allocatedInterest: this.jsAllocatedInterest,
            allocatedFees: this.jsAllocatedFees,
            allocatedTotal: this.jsAllocatedTotal,
            date: this.jsDate,
        };
    }
}
